import { render } from "./accountstatuschart.vue?vue&type=template&id=14650446&scoped=true"
import script from "./accountstatuschart.vue?vue&type=script&lang=js"
export * from "./accountstatuschart.vue?vue&type=script&lang=js"

import "./accountstatuschart.vue?vue&type=style&index=0&id=14650446&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14650446"]])

export default __exports__